var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-btn',{staticClass:"ml-0 mt-3",attrs:{"text":"","disabled":_vm.disabled,"height":"40px","min-width":"90px"},on:{"click":_vm.createReport}},[_c('v-icon',[_vm._v("mdi-download")]),_vm._v(" CSV ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }